import { Pill } from "PFComponents/pill";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { ShortlistWithScores } from "../types";

type ShortlistStateCellProps = {
  shortlist: ShortlistWithScores;
};

export const ShortlistStateCell = ({ shortlist }: ShortlistStateCellProps) => {
  const { t } = useTranslation("activities");

  return (
    <Pill small>
      <Typography variant="labelRegular">{t(`show.shortlist.state.${shortlist.state}`)}</Typography>
    </Pill>
  );
};
